import promptAmimation from "./promptAnimation";
import makeDelay from "./makeDelay";

const execDelay = (async function(textAnimation){
    await makeDelay(8000);
    promptAmimation(textAnimation, "development")
    await makeDelay(11000);
    promptAmimation(textAnimation, "OS windows/linux")
    await makeDelay(11000);
    promptAmimation(textAnimation, "database")
    await makeDelay(11000);
    promptAmimation(textAnimation, "<full_stack_web_development />", false)
    await makeDelay(32000)
        textAnimation.current.innerText = '';
        textAnimation.current.innerText = "<full_stack_web_development />";
})


export default execDelay;